import { useEffect } from "react";
import PageLayout from "../../components/shared/PageLayout";
import AnonymousQuestion from "../../components/anonymous/AnonymousQuestion";
import { StyledAnonymous } from "./index.styled";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import AnonymousQuestionsList from "../../components/anonymous/AnonymousQuestionsList";
import { fetchAnonymousQuestionsAction, fetchStatusMeAction } from "../../store/dashboardSlice";

const Anonymous = () => {
  const dispatch = useAppDispatch();
  const questions = useAppSelector(
    (state) => state.dashboard.data.anonymousQuestions
  );
  const status = useAppSelector((state) => state.dashboard.status);
  const statusId = status?.id;
  const ownerId = status?.owner_id;
  const anonymousQuestionsLoading = useAppSelector(
    (state) => state.dashboard.anonymousQuestionsLoading
  );

  useEffect(() => {
    if (!status) {
      void dispatch(fetchStatusMeAction());
    }
  }, [dispatch, status]);

  useEffect(() => {
    if (statusId !== undefined && ownerId !== undefined) {
      void dispatch(fetchAnonymousQuestionsAction(ownerId));
    }
  }, [dispatch, statusId, ownerId]);

  return (
    <PageLayout
      title="שאלות אנונימיות"
      StyledComponent={StyledAnonymous}
      containerClassName="anonymous-container"
      wrapInContainer={false}
    >
      <div className="anonymous-container">
        <AnonymousQuestion />
      </div>
      <AnonymousQuestionsList questions={questions} loading={anonymousQuestionsLoading} />
    </PageLayout>
  );
};

export default Anonymous;
